import React from 'react';
import { IonCardTitle, IonCardContent, IonLabel } from '@ionic/react';

type Props = {
  phones: [],
  emails: [],
  title: string,
};

const Contacts: React.FC<Props> = ({ phones, emails, title }) => {
  if (phones.length === 0 && emails.length === 0) {
    return (
      <IonCardContent>
        <IonCardTitle>{title}</IonCardTitle>
        <div>???</div>
      </IonCardContent>
    );
  }
  return (
    <div>
      <IonCardContent>
        <IonCardTitle>{title}</IonCardTitle>
        { phones.map((item: any, index: number) => {
            const number = item.phoneNumber;
            const formatted = `${number.substring(0, 3)}-${number.substring(3, 6)}-${number.substring(6, 10)}`;
            return (
              <div key={formatted+index}>
                <IonLabel>
                  {item.type}: <a href={`tel:${formatted}`}>{formatted} {item.extension}</a>
                </IonLabel>
              </div>
            );
          })
        }
        {
          emails.map((item: any, index: number) => {
            return (
              <IonLabel key={item.emailAddress+index}>
                  Email: <a href={`mailto:${item.emailAddress}`}>{item.emailAddress}</a>
              </IonLabel>
            );
          })
        }
      </IonCardContent>
    </div>
  );
};

export default Contacts;